<script>
export default {
  props: {
    cardtitle: {
      type: String,
      required: true,
    },
    optnumber: {
      type: String,
      required: false,
      default: () => '',
    },
  },
  data: () => ({}),
  computed: {
    showDialog: {
      get() {
        return this.dialog
      },
      set() {
        this.$emit('close-dialog')
      },
    },
    // instanceID() {
    //   return process.env.VUE_APP_MLECONFIG
    // },
    // enterpriseInstance() {
    //   return process.env.VUE_APP_INSTANCETYPE === 'ENTERPRISE'
    // },
    defaultLogo() {
      return process.env.VUE_APP_LOGO === 'MLE'
    },

    altLogoSize() {
      return process.env.VUE_APP_ALTLOGOSIZE
    },
  },

  methods: {
    confirmAction() {
      this.showDialog = false
      this.$emit('confirm')
    },
    routehome() {
      this.$router.push('/')
    },
  },
}
</script>

<template>
  <v-card-title :class="$style.dialogTitle">
    <!-- MLE LOGO -->
    <div v-if="defaultLogo">
      <img
        id="logo"
        src="@assets/images/mlelogo.png"
        height="32"
        style="margin: 0 20px"
        @click="routehome"
      />
    </div>
    <!-- DOCGILITY -->
    <!-- LOGO OPTIONS -->
    <div v-if="!defaultLogo">
      <img
        id="logo"
        src="@assets/images/logo.png"
        style="margin: 0 20px"
        :style="{ height: altLogoSize }"
        @click="routehome"
      />
    </div>
    <!-- LOGO OPTIONS END -->
    <span class="$style.dialogHeadline" text-color="white">{{
      cardtitle
    }}</span>
    <v-spacer></v-spacer>
    <div v-if="optnumber !== ''">
      <span class="$style.dialogHeadline">{{ $t(optnumber) }} </span>
    </div>
  </v-card-title>
</template>

<style lang="scss" module>
@import '@design';
</style>
